// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3097662a","453":"75ecd5f4","732":"768643d4"}[chunkId] + ".chunk.js";
};